module.exports = __webpack_public_path__ + "static/img/baas_main_1.fab6db7.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_main_1.png
// module id = 16x2
// module chunks = 0